import axios from "axios";
import { useFormik } from "formik";
import { useEffect, useState } from "react";
import toast, { Toaster } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import { CategoryAddSchema } from "../../../ValidationSchema";

const CategoryAdd = () => {
  const Navigate = useNavigate();
  // Field is named `name` (not `category_name`) to match CategoryAddSchema —
  // the schema validates `name`, so a mismatched field key here always left
  // `errors.name` set with nothing in the UI pointing at it. Formik then
  // silently refused to submit, and the button did nothing.
  const [initialValues] = useState({
    name: "",
  });

  const AddCategory = useFormik({
    initialValues,
    validationSchema: CategoryAddSchema,

    onSubmit: (values, action) => {
      axios
        .post(
          `${process.env.REACT_APP_URL}/admin/category`,
          { category_name: values.name },
          {
            headers: {
              Authorization: `Bearer ${localStorage.getItem("Token")}`,
            },
          }
        )
        .then((res) => {
          // if (res.status === 201) { // ✅ API returns 201 for success
          toast.success(`${res?.data?.message}`);
          Navigate("/admin/category", { state: res.data.data });
          // }
        })
        .catch((err) => {
          console.error(err);
          toast.error(err.response?.data?.message || "Something went wrong");
        });
    },
  });

  useEffect(() => {}, []);

  return (
    <div className="al">
      <Toaster position="top-center" reverseOrder={false} />

      <div className="al-head">
        <div>
          <h1 className="al-title">Add Category</h1>
          <p className="al-sub">Create a new product category.</p>
        </div>
        <div className="al-head__actions">
          <button type="button" className="al-btn" onClick={() => Navigate(-1)}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6" /></svg>
            Back
          </button>
        </div>
      </div>

      <form onSubmit={AddCategory.handleSubmit}>
        <div className="al-card">
          <div className="al-cardhead">
            <div className="al-cardhead__icon"><svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"><path d="M20.59 13.41 13.42 20.6a2 2 0 0 1-2.83 0L2 12V2h10l8.59 8.59a2 2 0 0 1 0 2.82z" /><line x1="7" y1="7" x2="7.01" y2="7" /></svg></div>
            <h3 className="al-cardhead__title">Category Details</h3>
          </div>
          <div className="al-form">
            <div className="al-form__full">
              <label className="al-label">Category Name <span className="al-req">*</span></label>
              <input className="al-input" type="text" placeholder="Enter Category Name"
                value={AddCategory.values.name}
                onChange={AddCategory.handleChange}
                onBlur={AddCategory.handleBlur}
                name="name" />
              {AddCategory.errors.name && AddCategory.touched.name && (
                <div className="al-err">{AddCategory.errors.name}</div>
              )}
            </div>
          </div>
          <div className="al-actionbar">
            <button type="button" className="al-btn" onClick={() => Navigate(-1)}>Cancel</button>
            <button type="submit" className="al-btn al-btn--primary">
              <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round"><line x1="12" y1="5" x2="12" y2="19" /><line x1="5" y1="12" x2="19" y2="12" /></svg>
              Create Category
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CategoryAdd;
